import callApi from "./callApi";

const actions = {
  ...callApi,
  resetPagination: ({ commit }) => {
    commit("resetPagination", { skip: 0, limit: 20, jenis: "", outlet: "" });
  },

  resetDataRiwayat: ({ commit }) => {
    commit("resetDataRiwayat");
  },

  resetlengthRiwayat: ({ commit }) => {
    commit("resetlengthRiwayat");
  },

  resetDetailTopUpToModal: ({ commit }) => {
    commit("resetDetailTopUpToModal");
  },
};

export default actions;
